import Web3 from "web3";
import { ENV } from "../config/config";
import { toast } from "react-toastify";
import governanceAbi from "./abi/governanceAbi.json";

const { requiredChainName } = ENV;
let { requiredChainIds } = ENV

requiredChainIds = Object.values(requiredChainIds)

const call = (method, params) => {
  return new Promise((resolve, reject) => {
    method(...params)
      .call()
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const send = (method, params, from, value) => {
  return new Promise((resolve, reject) => {
    method(...params)
      .send({ from, value })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const methods = {
  call,
  send,
};

export const getWeb3 = () => {
  if (window.ethereum) {
    const web3 = new Web3(window.ethereum);
    return web3;
  } else {
    return false;
  }
};

export const connectMetamask = async (web3 = null) => {
  if (!web3) {
    web3 = getWeb3();
  }
  if (!web3 || !window.ethereum) {
    toast.error("Please install Metamask Wallet in order to use all features of Marketplace")
    return;
  }

  await window.ethereum.enable();
  const accounts = await web3.eth.getAccounts();
  const chainId = await web3.eth.getChainId();
  if (!requiredChainIds.includes(chainId)) {
    localStorage.setItem("walletError", `Please switch to ${requiredChainName} in order to use all features of Marketplace`);
  }
  return accounts[0];
};

export const signRequest = async () => {
  if (window.ethereum) {
    const web3 = getWeb3();
    const accounts = await web3.eth.getAccounts();
    const address = accounts[0];
    const signature = await handleSignMessage(address);
    return signature;
  } else {
    alert(
      "Please install Metamask in order to use all features of Marketplace"
    );
  }
};

const accountsChangedHandler = () => {
  let error = `Please switch to ${requiredChainName} in order to use all features of Marketplace`;
  if (window.ethereum) {
    window.ethereum.on("accountsChanged", function (accounts) {
      localStorage.clear()
    });
    window.ethereum.on("chainChanged", function (_chainId) {
      let chaindId = parseInt(_chainId, 16);
      if (requiredChainIds.includes(chaindId)) {
        localStorage.removeItem("walletError");
      } else {
        localStorage.setItem("walletError", error);
      }
    });
    let web3 = new Web3(window.ethereum);
    web3.eth.net.getId().then((e) => {
      if (requiredChainIds.includes(e)) {
        localStorage.removeItem("walletError");
      } else {
        localStorage.setItem("walletError", error);
      }
    });
  }
}

const handleSignMessage = (address) => {
  return new Promise((resolve, reject) => {
    const web3 = getWeb3();
    web3.eth.personal.sign(
      web3.utils.fromUtf8(
        `${ENV.appName} uses this cryptographic signature in place of a password, verifying that you are the owner of this address.`
      ),
      address,
      (err, signature) => {
        if (err) return reject(err);
        return resolve(signature);
      }
    );
  });
};

export const weitoEth = async (amount) => {
  const web3 = await getWeb3();
  if (!web3 || !amount) {
    return 0;
  }
  const etherValue = await web3.utils.fromWei(`${amount}`, "ether");
  return etherValue;
};

accountsChangedHandler();

export const getConnectedAddress = () => {
  const address = localStorage.getItem("address");
  return address;
};

export const finalizeVoteResult = async (proposalId, scores, dstChainId) => {
  scores = scores.map((score) => parseInt(score));
  const web3 = await getWeb3();
  const connectedAddress = await getConnectedAddress();

  if (connectedAddress !== ENV.adminAddress) {
    alert("Only admin can finalize the vote result.")
  }

  try {
    if (await isVoteFinalized(proposalId)) {
      alert("Vote already finalized.")
      return false;
    }

    const governanceContract = new web3.eth.Contract(
      governanceAbi,
      ENV.contractAddress.bscGovernance
    );

    const gasEstimate = await methods.call(
      governanceContract.methods.estimateFees,
      [dstChainId, proposalId, scores]
    );

    const gasRequired = gasEstimate.nativeFee;

    const res = await methods.send(
      governanceContract.methods.finalizeVote,
      [proposalId, scores, dstChainId],
      connectedAddress,
      gasRequired
    );
    alert("Vote Finalized Successfully")
    return res;
  } catch (e) {
    // alert("Something wrong finalize vote result.")
    console.log(e);
    return false;
  }
}

export const isVoteFinalized = async (proposalId) => {
  const web3 = await getWeb3();

  try {
    const governanceContract = new web3.eth.Contract(
      governanceAbi,
      ENV.contractAddress.bscGovernance
    );
    const finalized = await methods.call(
      governanceContract.methods.proposalResults,
      [proposalId]
    );
    return finalized;
  } catch (e) {
    // alert("Something wrong finalize vote result.")
    console.log(e);
    return false;
  }
}
